<template>
  <div class="popover-container">
    <div @click.stop="toggle">
      <slot name="trigger"></slot>
    </div>
    <div v-if="isOpen" class="popover-content" :style="`width: ${width}px;`" ref="popoverContent">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, onBeforeUnmount, defineProps, defineEmits } from 'vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 200
  }
});

const emit = defineEmits(['update:isOpen']);

const popoverContent = ref<any>(null);

const localIsOpen = ref(props.isOpen);

const toggle = (event: any) => {
  if (props.disabled) return;
  event.stopPropagation(); // Prevent the event from propagating to the document
  localIsOpen.value = !localIsOpen.value;
  emit('update:isOpen', localIsOpen.value);
};

const handleClickOutside = (event: any) => {
  if (popoverContent.value && !popoverContent.value.contains(event.target)) {
    localIsOpen.value = false;
    emit('update:isOpen', localIsOpen.value);
  }
};

watch(() => props.isOpen, (newVal) => {
  localIsOpen.value = newVal;
});

onMounted(() => {
  if (process.client) {
    document.addEventListener('click', handleClickOutside);
  }
});

onBeforeUnmount(() => {
  if (process.client) {
    document.removeEventListener('click', handleClickOutside);
  }
});
</script>

<style scoped>
.popover-container {
  position: relative;
  display: block;
}
#feed-popover .popover-container {

  width: 24px;
}
.popover-content {
  position: absolute;
  top: calc(100% + 15px);
  right: 0;
  background-color: #fafafa;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  overflow: hidden;
  width: 100px;
}

.upload-popover .popover-content {
  top: 100%;
}
</style>
